module.exports = __webpack_public_path__ + "static/media/StepguideSpiderCR.dfcdde4b.PNG";